import React from 'react';
import { Row, Col } from 'antd';
import CustomInput from '../../../../../../components/CustomInput';

export default function DetailsUrlsInputs({ onChange, flag, data, errors }) {
    return (
        <div className="details-table">
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            Web site
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell details-table__cell--editable">
                            <CustomInput
                                className="input-dark"
                                id={`web_site_url_${flag}`}
                                placeholder="Enter Web site URL"
                                onInputChange={(e) => onChange(e, flag)}
                                inputValue={data[flag]?.web_site_url}
                                width="100%"
                                errorText={
                                    errors?.[
                                        `countries_localizations.${flag}.web_site_url`
                                    ]
                                }
                            />
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            {`Terms & Conditions`}
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell details-table__cell--editable">
                            <CustomInput
                                className="input-dark"
                                id={`terms_conditions_url_${flag}`}
                                placeholder={`Enter Terms & Conditions URL`}
                                onInputChange={(e) => onChange(e, flag)}
                                inputValue={data[flag]?.terms_conditions_url}
                                width="100%"
                                errorText={
                                    errors?.[
                                        `countries_localizations.${flag}.terms_conditions_url`
                                    ]
                                }
                            />
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            Support page
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell details-table__cell--editable">
                            <CustomInput
                                className="input-dark"
                                id={`support_page_url_${flag}`}
                                placeholder="Enter Support page URL"
                                onInputChange={(e) => onChange(e, flag)}
                                inputValue={data[flag]?.support_page_url}
                                width="100%"
                                errorText={
                                    errors?.[
                                        `countries_localizations.${flag}.support_page_url`
                                    ]
                                }
                            />
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            Blog page
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell details-table__cell--editable">
                            <CustomInput
                                className="input-dark"
                                id={`blog_page_url_${flag}`}
                                placeholder="Enter Blog page URL"
                                onInputChange={(e) => onChange(e, flag)}
                                inputValue={data[flag]?.blog_page_url}
                                width="100%"
                                errorText={
                                    errors?.[
                                        `countries_localizations.${flag}.blog_page_url`
                                    ]
                                }
                            />
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            Privacy Policy
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell details-table__cell--editable">
                            <CustomInput
                                className="input-dark"
                                id={`privacy_policy_url_${flag}`}
                                placeholder="Enter Privacy Policy URL"
                                onInputChange={(e) => onChange(e, flag)}
                                inputValue={data[flag]?.privacy_policy_url}
                                width="100%"
                                errorText={
                                    errors?.[
                                        `countries_localizations.${flag}.privacy_policy_url`
                                    ]
                                }
                            />
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            Web App
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell details-table__cell--editable">
                            <CustomInput
                                className="input-dark"
                                id={`web_app_url_${flag}`}
                                placeholder="Enter Web App URL"
                                onInputChange={(e) => onChange(e, flag)}
                                inputValue={data[flag]?.web_app_url}
                                width="100%"
                                errorText={
                                    errors?.[
                                        `countries_localizations.${flag}.web_app_url`
                                    ]
                                }
                            />
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            CRM
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell details-table__cell--editable">
                            <CustomInput
                                className="input-dark"
                                id={`crm_url_${flag}`}
                                placeholder="Enter CRM URL"
                                onInputChange={(e) => onChange(e, flag)}
                                inputValue={data[flag]?.crm_url}
                                width="100%"
                                errorText={
                                    errors?.[
                                        `countries_localizations.${flag}.crm_url`
                                    ]
                                }
                            />
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            Facebook
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell details-table__cell--editable">
                            <CustomInput
                                className="input-dark"
                                id={`facebook_url_${flag}`}
                                placeholder="Enter Facebook URL"
                                onInputChange={(e) => onChange(e, flag)}
                                inputValue={data[flag]?.facebook_url}
                                width="100%"
                                errorText={
                                    errors?.[
                                        `countries_localizations.${flag}.facebook_url`
                                    ]
                                }
                            />
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            App Store
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell details-table__cell--editable">
                            <CustomInput
                                className="input-dark"
                                id={`app_store_url_${flag}`}
                                placeholder="Enter App Store URL"
                                onInputChange={(e) => onChange(e, flag)}
                                inputValue={data[flag]?.app_store_url}
                                width="100%"
                                errorText={
                                    errors?.[
                                        `countries_localizations.${flag}.app_store_url`
                                    ]
                                }
                            />
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            Google Play
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell details-table__cell--editable">
                            <CustomInput
                                className="input-dark"
                                id={`google_play_url_${flag}`}
                                placeholder="Enter Google Play URL"
                                onInputChange={(e) => onChange(e, flag)}
                                inputValue={data[flag]?.google_play_url}
                                width="100%"
                                errorText={
                                    errors?.[
                                        `countries_localizations.${flag}.google_play_url`
                                    ]
                                }
                            />
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            Twitter
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell details-table__cell--editable">
                            <CustomInput
                                className="input-dark"
                                id={`twitter_url_${flag}`}
                                placeholder="Enter Twitter URL"
                                onInputChange={(e) => onChange(e, flag)}
                                inputValue={data[flag]?.twitter_url}
                                width="100%"
                                errorText={
                                    errors?.[
                                        `countries_localizations.${flag}.twitter_url`
                                    ]
                                }
                            />
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            LinkedIn
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell details-table__cell--editable">
                            <CustomInput
                                className="input-dark"
                                id={`linkedIn_url_${flag}`}
                                placeholder="Enter LinkedIn URL"
                                onInputChange={(e) => onChange(e, flag)}
                                inputValue={data[flag]?.linkedIn_url}
                                width="100%"
                                errorText={
                                    errors?.[
                                        `countries_localizations.${flag}.linkedIn_url`
                                    ]
                                }
                            />
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            Contact us URL
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell details-table__cell--editable">
                            <CustomInput
                                className="input-dark"
                                id={`contact_us_url_${flag}`}
                                placeholder="Enter Contact us URL"
                                onInputChange={(e) => onChange(e, flag)}
                                inputValue={data[flag]?.contact_us_url}
                                width="100%"
                                errorText={
                                    errors?.[
                                        `countries_localizations.${flag}.contact_us_url`
                                    ]
                                }
                            />
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            Contact us email
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell details-table__cell--editable">
                            <CustomInput
                                className="input-dark"
                                id={`contact_us_email_${flag}`}
                                placeholder="Enter Contact us email"
                                onInputChange={(e) => onChange(e, flag)}
                                inputValue={data[flag]?.contact_us_email}
                                width="100%"
                                errorText={
                                    errors?.[
                                        `countries_localizations.${flag}.contact_us_email`
                                    ]
                                }
                            />
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            Instagram
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell details-table__cell--editable">
                            <CustomInput
                                className="input-dark"
                                id={`instagram_url_${flag}`}
                                placeholder="Enter Instagram URL"
                                onInputChange={(e) => onChange(e, flag)}
                                inputValue={data[flag]?.instagram_url}
                                width="100%"
                                errorText={
                                    errors?.[
                                        `countries_localizations.${flag}.instagram_url`
                                    ]
                                }
                            />
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            Youtube
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell details-table__cell--editable">
                            <CustomInput
                                className="input-dark"
                                id={`youtube_url_${flag}`}
                                placeholder="Enter Youtube URL"
                                onInputChange={(e) => onChange(e, flag)}
                                inputValue={data[flag]?.youtube_url}
                                width="100%"
                                errorText={
                                    errors?.[
                                        `countries_localizations.${flag}.youtube_url`
                                    ]
                                }
                            />
                        </div>
                    </Col>
                </Row>
            </div>
        </div>
    );
}
